jQuery(document).ready(function($) {
    $(document).on('change', '.variation-radios input[type="radio"]', function() {
        var name = $(this).attr('name');
        var value = $(this).val();

        $('select[name="' + name + '"]').val(value).trigger('change');

        $('input[name="' + name + '"]').each(function() {
            $(this).closest('label').removeClass('active-radio-label');
        });

        $('input[name="' + name + '"]:checked').closest('label').addClass('active-radio-label');
    });

    $('.variation-radios input[type="radio"]:checked').each(function() {
        $(this).closest('label').addClass('active-radio-label');
    });

    $('form.variations_form').trigger('woocommerce_variation_select_change');
});
